module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/pop-btn-a47e94c8dae9ca09c9b0110cc2a56007.png";